module.exports = __webpack_public_path__ + "static/flags/CW-28c93797b61f5b490305feb200d7d485.gif";